// extracted by mini-css-extract-plugin
export default {"root":"_403_root__cLmAM","description":"_403_description__thWUC","link":"_403_link__SbAaj"};